import { GUESTY_LISTING_ALREADY_LINKED_ERROR } from "./error-codes.constants";

export class GuestyListingAlreadyLinkedError extends Error {
  code: string;
  conflictingRoomName?: string;

  constructor(conflictingRoomName?: string) {
    super("Guesty listing already linked error");
    this.name = "GuestyListingAlreadyLinkedError";
    this.code = GUESTY_LISTING_ALREADY_LINKED_ERROR;
    this.conflictingRoomName = conflictingRoomName;
  }
}
